import * as yup from 'yup';

export const SWEDISH_SSN_REGEX = /^[\d-]+$/;

export function validateSwedishSsn(isRequired = false) {
  const base = yup
    .string()
    .trim()
    .matches(/^[\d-]+$/, 'Personnummer kan endast innehålla nummer');

  if (isRequired) {
    return base.length(11, 'Personnummer måste vara exakt tio siffror långt');
  }

  return base;
}

export const validateSwedishSsnFormatting = [
  SWEDISH_SSN_REGEX,
  'Personnummer måste vara exakt tio siffror långt',
] as const;

export const validateSwedishOrganizationNumber = yup
  .string()
  .trim()
  .length(11, 'Organisationsnumret måste vara tio siffror långt')
  .matches(/^[\d-]+$/, 'Organisationsnummer kan endast innehålla nummer');
